<footer class="aqx-footer bg-dark p-3 small">
    &copy; Aqaix {{yearForCopyrightNotice}}
</footer>
